<!-- 系统-设置 -->
<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea timedTasks">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <BreadCrumb></BreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <div class="addBtn">
          <el-button type="primary" @click="addDio = true">添加</el-button>
        </div>
        <el-table :data="taskData" style="width:100%;" v-loading="tableloading">
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column label="任务名称" prop="name"></el-table-column>
          <el-table-column label="任务地址" prop="task_address" width="300" show-overflow-tooltip></el-table-column>
          <el-table-column label="创建时间" prop="create_time"></el-table-column>
          <el-table-column label="最后执行时间" prop="execute_time"></el-table-column>
          <el-table-column label="当前状态">
            <template slot-scope="scope">
              <el-button @click="openStatus(scope.$index)" class="colRed" type="text" v-if="scope.row.status == '0'">暂停</el-button>
              <el-button @click="openStatus(scope.$index)" type="text" v-else>执行</el-button>
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="desc" width="300" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" width="90">
            <template slot-scope="scope">
              <el-button type="text" @click="openEdit(scope.$index)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paging" v-if="total>limits">
          <el-pagination
            @current-change="CurrentChange"
            :current-page.sync="curr"
            :page-size="limits"
            layout="prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>

      <!--添加-->
      <el-dialog title="添加" :visible.sync="addDio" width="480px">
        <div class="cont_dio">
          <el-form ref="form" :model="addform" label-width="90px" :rules="rules">
            <el-form-item label="任务名称:" prop="taskName">
              <el-input v-model="addform.taskName" placeholder="请输入任务名称"></el-input>
            </el-form-item>
            <el-form-item label="任务地址:" prop="address">
              <el-input v-model="addform.address" placeholder="请输入任务地址"></el-input>
            </el-form-item>
            <el-form-item label="执行间隔:" prop="interval">
              <el-input placeholder="执行间隔" v-model="addform.interval">
                <template slot="append">秒（s）</template>
              </el-input>
            </el-form-item>
            <el-form-item label="备注:">
              <el-input type="textarea" rows="4" v-model="addform.desc" placeholder="备注"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="addSubmit('form','add')">确认</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
      <!--修改-->
      <el-dialog title="修改" :visible.sync="editDio" width="480px">
        <div class="cont_dio">
          <el-form ref="form2" :model="editform" label-width="90px" :rules="rules">
            <el-form-item label="任务名称:" prop="taskName">
              <el-input v-model="editform.taskName" placeholder="请输入任务名称"></el-input>
            </el-form-item>
            <el-form-item label="任务地址:" prop="address">
              <el-input v-model="editform.address" placeholder="请输入任务地址"></el-input>
            </el-form-item>
            <el-form-item label="执行间隔:" prop="interval">
              <el-input placeholder="执行间隔" v-model="editform.interval">
                <template slot="append">秒（s）</template>
              </el-input>
            </el-form-item>
            <el-form-item label="备注:">
              <el-input type="textarea" rows="4" v-model="editform.desc" placeholder="备注"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="addSubmit('form2','edit')">确认</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
      <!--修改状态-->
      <el-dialog title="" :visible.sync="statusDio" width="600px">
        <div class="statusCont">
          <div>当前定时任务状态为<span v-if="statusform.status == '0'">暂停</span><span v-else>执行</span></div>
          <div>是否将状态改为<span v-if="statusform.status == '1'">暂停</span><span v-else>执行</span></div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="statusDio = false">取 消</el-button>
          <el-button @click="changeStatus">{{statusform.status == '1' ? '暂停' : '执行'}}</el-button>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import BreadCrumb from "../../Layout/BreadCrumb.vue"
import { showToast, deepCopy } from "../../../../static/js/utility/utility.js"
  import { systemApi } from "../../../../static/js/api.js"

  export default {
    name: 'timedTasks',
    components: {
      BreadCrumb
    },
    data() {
      return {
        tableloading:false,
        taskData:[],//任务列表

        //分页
        curr:1,
        limits:10,
        total:0,

        addDio:false,
        addform:{
          taskName:'',//任务名称
          address:'',//任务地址
          interval:'',//执行间隔(单位:秒（s）)
          desc:'',//备注
        },
        rules:{
          taskName:[
            { required: true, message: '请输入任务名称', trigger: 'blur' },
          ],
          address:[
            { required: true, message: '请输入任务地址', trigger: 'blur' },
          ],
          interval:[
            { required: true, message: '请输入执行间隔', trigger: 'blur' },
          ],
        },

        editDio:false,
        editform:{
          id:'',
          taskName:'',//任务名称
          address:'',//任务地址
          interval:'',//执行间隔(单位:秒（s）)
          desc:'',//备注
        },

        statusDio:false,//状态弹窗
        statusform:{
          id:'',
          status:'',
        }
      }
    },
    mounted(){
      
    },
    created: async function () {
      this.getTaskList()
    },
    methods: {
      //修改状态
      async changeStatus(){
        let that = this;
        const dataObj = {
          'id': that.statusform.id,
          'status': that.statusform.status =='0' ? '1':'0'
        }
        const res = await systemApi.changeStatus(dataObj)
        if(res.meta.code == 200) {
          showToast('状态修改成功！')
          that.getTaskList()
          that.statusDio = false
        }else{
          showToast(res.meta.message)
        }
      },
      //打开修改状态
      openStatus(index){
        this.statusform.id = this.taskData[index].id
        this.statusform.status = this.taskData[index].status
        this.statusDio = true
      },
      //打开修改弹窗
      openEdit(index){
        this.editform = {
          id: this.taskData[index].id,
          taskName: this.taskData[index].name,
          address: this.taskData[index].task_address,
          interval: this.taskData[index].time,
          desc: this.taskData[index].desc,
        }
        this.editDio = true
      },
      //更新定时任务验证
      addSubmit(formName,type){
        let that = this
        that.$refs[formName].validate((valid) => {
          if (valid) {
            that.updateTask(type);
          }else {
            return false;
          }
        });
      },
      //更新定时任务
      async updateTask(type){
        let that = this;
        if(type == 'add'){
          var dataObj = {
            'name': that.addform.taskName,
            'task_address': that.addform.address,
            'time': that.addform.interval,
            'desc': that.addform.desc,
            'flag': type,
          }
        }else{
          var dataObj = {
            'id': that.editform.id,
            'name': that.editform.taskName,
            'task_address': that.editform.address,
            'time': that.editform.interval,
            'desc': that.editform.desc,
            'flag': type,
          }
        }
        const res = await systemApi.updateTask(dataObj)
        if(res.meta.code == 200){
          if(type == 'add'){
            that.addDio = false
            that.addform = {
              taskName:'',
              address:'',
              interval:'',
              desc:'',
            }
            showToast('添加成功！')
          }else{
            that.editDio = false
            that.editform = {
              id:'',
              taskName:'',
              address:'',
              interval:'',
              desc:'',
            }
            showToast('修改成功！')
          }
          that.getTaskList()
        }else{
          showToast(res.meta.message)
        }
      },
      //获取定时任务列表
      async getTaskList(curr,limits){
        let that = this;
        const dataObj = {
          'page': curr ? curr : that.curr,
          'perPage': limits ? limits : that.limits,
        }
        this.tableloading = true;
        const res = await systemApi.getTaskList(dataObj)
        if(res.meta.code == 200) {
          that.taskData = res.data.list
          that.total = parseInt(res.data.count)
          that.tableloading = false;
        }else{
          this.tableloading = false;
          showToast(res.meta.message)
        }
      },
      //点击当前页调用接口
      CurrentChange(val){
        this.curr = val
        this.getTaskList(val)
      },
    },
    watch: {
      
    }
  }
</script>

<style lang="scss">
.timedTasks {
  .cont_dio{
    .el-select .el-input {
      width: 90px;
    }
    .el-input-group__append{
      background-color: #fff;
    }
  }
  .colRed{
    color:#F56C6C;
  }
  .statusCont{
    line-height: 30px;
    font-size: 14px;
    span{
      font-weight: bold;
      margin-left: 10px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Page/System/timedTasks.vue